import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContaCosifDs,
  criarServicosIssDs,
} from "../../DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ServicosIssBox from "../servicosIss/ServicosIssBox";
import { Button, ScrollView } from "devextreme-react";
import Memoria from "../../Memoria";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  codigo: undefined,
  servicoId: undefined,
  descricao: "",
  prefeituraId: undefined,
  popupServicoVisivel: false,
};

export default class ContasCosifForm extends React.Component {
  constructor(props) {
    super(props);
    this.contaCosifDs = criarContaCosifDs();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.state = { ...(_cadastroCorrente || template) };
    this.servicoBoxRef = React.createRef();
    this.onServicoSelecionado = this.onServicoSelecionado.bind(this);
    this.setServicoId = this.setServicoId.bind(this);
    this.setDescricaoServico = this.setDadosServico.bind(this);
    this.atualizarDescricaoServico = this.atualizarDescricaoServico.bind(this);
    this.servicoIssDs = criarServicosIssDs();
    this.atualizarDescricaoServicoId = this.atualizarDescricaoServicoId.bind(
      this
    );
    this.pesquisarServico = this.pesquisarServico.bind(this);

    this.renderServico = sysCodigoDescricao(
      () => this.state.servicoId,
      this.setServicoId,
      () => this.state._uiServico,
      this.pesquisarServico
    );
  }

  setServicoId(e) {
    this.setState({ servicoId: e.value });
    this.atualizarDescricaoServico();
  }

  atualizarDescricaoServico() {
    this.servicoIssDs
      .load({ filter: [["sequencial", "=", this.state.servicoId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setDadosServico(result[0]);
        } else {
          this.setDadosServico(null);
        }
      })
      .catch((_) => this.setDadosServico(null));
  }

  atualizarDescricaoServicoId() {
    this.servicoIssDs
      .load({ filter: [["id", "=", this.state.servicoId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setDadosServico(result[0]);
        } else {
          this.setDadosServico(null);
        }
      })
      .catch((_) => this.setDadosServico(null));
  }

  setDadosServico(servico) {
    if (servico == undefined) {
      this.setState({
        servicoId: null,
        _uiServico: "",
        aliquotaIss:
          this.state.tributacaoIss != 3 ? null : this.state.aliquotaIss,
        popupServicoVisivel: false,
      });
    } else {
      this.setState({
        servicoId: servico.id,
        _uiServico: servico.descricao,
        _uiServicoSequencial: servico.sequencial,
        aliquotaIss:
          this.state.tributacaoIss != 3
            ? servico.aliquotaIss
            : this.state.aliquotaIss,
        popupServicoVisivel: false,
      });
    }
  }

  onServicoSelecionado(e, entidadeDireta) {
    let servico = entidadeDireta;
    if (servico == undefined && e && e.row && e.row.data) {
      servico = e.row.data;
    }
    this.setDadosServico(servico);
  }

  /* atualizarNomeServico() {
    this.servicoDs
      .load({ filter: [["id", "=", this.state.servicoId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeServico(result[0]);
        } else {
          this.setNomeServico(undefined);
        }
      })
      .catch((_) => this.setNomeServicoErro());
  } */

  pesquisarServico(e) {
    this.setState({ popupServicoVisivel: true });
  }

  componentDidMount() {
    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.contaCosifDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data === undefined) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/contascosif");
            }
            this.setState({
              ...data,
            });
            this.atualizarDescricaoServicoId();
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="DADOS DA CONTA" colSpan={2} colCount={4}>
                <SimpleItem dataField={"codigo"} colSpan={1}>
                  <Label text="Código" />
                </SimpleItem>
                <EmptyItem></EmptyItem>
                <EmptyItem></EmptyItem>
                <EmptyItem></EmptyItem>
                <SimpleItem
                  dataField={"descricao"}
                  colSpan={4}
                  editorType="dxTextArea"
                  editorOptions={{ height: 90 }}
                >
                  <Label text="Descrição" />
                </SimpleItem>
                <SimpleItem
                  dataField={"servico"}
                  colSpan={4}
                  component={this.renderServico}
                >
                  <Label text="Serviço" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupServicoVisivel}
            onHiding={() => this.setState({ popupServicoVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Serviço"
          >
            <ScrollView showScrollbar={"always"}>
              <ServicosIssBox
                onSelecionado={this.onServicoSelecionado}
                ref={this.servicoBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupServicoVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.contaCosifDs, entidade)
      .then(
        function () {
          notify("Conta Cosif criada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
